import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcEmailIcon, IcSCopyIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton } from '@gem/ui-kit';

import { User } from 'STORE/Users/User/User';

import { MetaBlock } from '../MetaBlock/MetaBlock';
import { useProfileNicknamePresenter } from './ProfileNickname.presenter';
import styles from './ProfileNickname.styles.m.css';

interface IProfileNicknameProps {
  className?: string;
  user: User;
}

export const ProfileNickname: FC<IProfileNicknameProps> = observer(({ className, user }) => {
  const { t } = useTranslation();
  const { copyToClipboard } = useProfileNicknamePresenter(user);

  return (
    <MetaBlock
      className={className}
      label={t('profile_nickname_hint')}
      Icon={IcEmailIcon}
      Actions={
        <IconButton
          Icon={IcSCopyIcon}
          onClick={copyToClipboard}
        />
      }
    >
      <button
        className={styles.link}
        onClick={copyToClipboard}
        data-test="nickname"
      >
        {user.displayNickname}
      </button>
    </MetaBlock>
  );
});
